import { render, staticRenderFns } from "./UserHeaderDropdown.vue?vue&type=template&id=6852a936&"
import script from "./UserHeaderDropdown.vue?vue&type=script&lang=js&"
export * from "./UserHeaderDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports